import axios from "axios";
import { getAuth } from "firebase/auth";

export const apiPayment = axios.create({
	baseURL: process.env.REACT_APP_URL_API_PAYOUT,
	headers: {
		"content-type": "application/json",
	},
});

export const createdApi = (baseURL) => {
	const api = axios.create({
		baseURL: baseURL,
		headers: {
			"content-type": "application/json",
		},
	});

	let authInitialized = null;
	const waitForAuthInit = () => {
		if (!authInitialized) {
			const auth = getAuth();
			authInitialized = new Promise((resolve) => {
				const unsubscribe = auth.onAuthStateChanged(() => {
					unsubscribe();
					resolve();
				});
			});
		}
		return authInitialized;
	};

	api.interceptors.request.use(
		async (config) => {
			await waitForAuthInit();
			const currentUser = getAuth().currentUser;

			const accessToken = localStorage.getItem("accessToken");
			let token = accessToken ? accessToken : null;

			if (currentUser) {
				token = currentUser.accessToken;
				config.headers.Authorization = `Bearer ${token}`;
			} else if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			} else {
				return Promise.reject(new Error("No auth token available"));
			}
	
			config.headers["User-Agent"] = "WebBusiness";

			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	api.interceptors.response.use(
		(response) => response,
		async (error) => {
			const originalRequest = error.config;
			if (error.response?.status === 401 && !originalRequest._retry) {
				const currentUser = getAuth().currentUser;
				originalRequest._retry = true;
				if (!currentUser) {
					return Promise.reject(error);
				}
				await currentUser.getIdToken(true);
				return api(originalRequest);
			}
			if (error.message?.includes("Network Error") || error.response?.status === 0) {
				return Promise.reject(error);
			}
	
			return Promise.reject(error);
		}
	);

	return api;
};
	
	apiPayment.interceptors.request.use(
		async (config) => {
			const accessToken = localStorage.getItem("accessToken");
			let token = accessToken ? accessToken : null;

			const currentUser = getAuth().currentUser;

			if (currentUser) {
				token = currentUser.accessToken;
				config.headers.Authorization = `Bearer ${token}`;
			} else if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			} else {
				return Promise.reject(new Error("No auth token available"));
			}
	
			config.headers["User-Agent"] = "WebBusiness";

			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	apiPayment.interceptors.response.use(
		(response) => response,
		async (error) => {
			const originalRequest = error.config;
			if (error.response?.status === 401 && !originalRequest._retry) {
				const currentUser = getAuth().currentUser;
				originalRequest._retry = true;
				if (!currentUser) {
					return Promise.reject(error);
				}
				await currentUser.getIdToken(true);
				return api(originalRequest);
			}
			if (error.message?.includes("Network Error") || error.response?.status === 0) {
				return Promise.reject(error);
			}
	
			return Promise.reject(error);
		}
	);


const api = createdApi(process.env.REACT_APP_URL_API)

export default api;
